import { Injector, runInInjectionContext } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState } from '@ngrx/signals';
import { tap } from 'rxjs';
import { GetRegioneGQL } from '../../_graphql/generated';

export const getRegione =
  (injector: Injector, store: any, getter: GetRegioneGQL) => () =>
    runInInjectionContext(injector, () => {
      return getter
        .fetch(
          {},
          {
            context: { headers: { 'x-hasura-role': 'anonymous' } },
            fetchPolicy: 'cache-first',
          },
        )
        .pipe(
          tap(() => patchState(store, { loading: true })),
          tapResponse({
            next: (res) => {
              patchState(store, {
                loading: false,
                lista: res.data?.unita_amministrativa_regione,
                failure: undefined,
              });
            },
            error: (error) => {
              patchState(store, {
                loading: false,
                failure: error,
              });
            },
          }),
        );
    });
